import { XPlanMigratorManager } from "./XPlanMigrator/XplanMigratorManager";

export class AusplanAppsManager {
    static xplanMigrator = new XPlanMigratorManager();
}
